import { gql } from '@apollo/client';
import userLicenseFragment from '../userLicenseFragment';

const GET_PAID_USERS = gql`
  query GetPaidUsers($organizationId: Int, $orgUnitId: Int) {
    paidUsers(organizationId: $organizationId, orgUnitId: $orgUnitId) {
      ...UserLicenseFields
    }
    licenseInformation(organizationId: $organizationId, orgUnitId: $orgUnitId) {
      Organization {
        licenseTotal: PaidTotal
        licenseAssigned: PaidAssigned
      }
      OrgUnits {
        OrgUnitId
        OrgUnitName
        licenseTotal: PaidTotal
        licenseAssigned: PaidAssigned
      }
    }
  }
  ${userLicenseFragment}
`;

export default GET_PAID_USERS;
